import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Popup } from "devextreme-react/popup";
import {
    DataGrid,
    Column,
    Scrolling,
    FilterRow,
    LoadPanel,
} from "devextreme-react/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";

function CustomerItemHistoryPopup(props) {
    const { showPopup = {}, setShowPopup, oidc } = props;
    const visible = showPopup.visible === true;
    var accessToken = props.oidc.user.access_token;

    const dataSource = useMemo(() => {
        return createStore({
            key: 'Rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/om/SalesOrderDetailOperations/GetCustomerItemHistory`,
            loadParams: {
                RItem: showPopup.RItem,
                RTransactionHeader: showPopup.HeaderRowId,
                RCustomer: showPopup.CustomerId

            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    Key: showPopup.RItem,
                };
            }
        });
    }, [showPopup.RItem, showPopup.HeaderRowId, showPopup.CustomerId]);

    const handleHiding = () => {
        setShowPopup((prev) => ({ ...prev, visible: false }));
    };

    return (
        <>
            {visible ? (
                <Popup
                    visible={true}
                    onHiding={handleHiding}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showCloseButton={true}
                    showTitle={true}
                    title={showPopup.title ?? "Customer Item History"}
                    container="#root"
                    width="100vw"
                    height="100vh"
                >
                    <DataGrid
                        dataSource={dataSource}
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        hoverStateEnabled={true}
                        height="100%"
                        showColumnLines={true}
                        showRowLines={true}
                        paging={false}
                    >
                        <Scrolling mode="standard" />
                        <LoadPanel enabled={true} />
                        <FilterRow visible={true} />
                        <Column dataField="TransactionNumber" caption="Transaction #" dataType="string" />
                        <Column dataField="TransactionDate" caption="Order" dataType="date" format="shortDate" />
                        <Column dataField="InvoiceDate" caption="Invoice" dataType="date" format="shortDate" />
                        <Column dataField="ShippingDate" caption="Ship" dataType="date" format="shortDate" />
                        <Column dataField="PurchaseOrderNumber" caption="PO Number" dataType="string" />
                        <Column dataField="QuantityOrder" caption="Ordered" dataType="number" format="#,##0.##" />
                        <Column dataField="QuantityShipped" caption="Shipped" dataType="number" format="#,##0.##" />
                        <Column dataField="UnitPrice" caption="Unit Price" dataType="number" format={{
                            type: 'currency',
                            precision: 4,
                            currency: 'USD',
                            useGrouping: true
                        }} />
                        <Column dataField="Amount" caption="Amount" dataType="number" format={{
                            type: 'currency',
                            precision: 2,
                            currency: 'USD',
                            useGrouping: true
                        }} />
                    </DataGrid>
                </Popup>
            ) : null}
        </>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CustomerItemHistoryPopup);
